// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20.414'
    height='20.414'
    viewBox='0 0 20.414 20.414'
    ...attributes
  ><g
      fill='var(--icon-bg,none)'
      stroke='var(--icon-color, #000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='var(--icon-stroke-width,2)'
      transform='translate(-2 -2)'
    ><circle cx='11' cy='11' r='8' /><path d='m21 21-4.35-4.35' /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconSearch';
export default IconComponent;
